import styled from 'styled-components/macro'

export const HomeContainer = styled.div`
    width: 100%;
    height: 100%;
    min-height: 39.5rem; //DESKTOP
    display: flex;
    align-items: flex-start;
    margin-top: 3rem;
    overflow: hidden;
`